import DOMPurify from "dompurify";

/* Every link we render comes from outside (event bodies, mail bodies, signatures):
   open it in a new tab so it never navigates the SPA away, and cut the opener. */
DOMPurify.addHook("afterSanitizeAttributes", (node) => {
    const link = node as Element;
    const href = link.nodeName === "A" ? link.getAttribute("href") : null;

    if (!href || href.startsWith("#")) return;

    link.setAttribute("target", "_blank");
    link.setAttribute("rel", "noopener noreferrer");
});

const sanitizeHTML = (html: string): string => DOMPurify.sanitize(html);

export default sanitizeHTML;
